import {uiGameManager} from '../../shared/scripts/EntryShared.ts'
import {UIUtilsEjsVariables} from './UIUtilsEjsVariables.ts'

export namespace GameFont {

    export enum Size {
        Small = 10,
        Normal = 12,
        L = 14,
        XL = 16,
        XXL = 26,
        XXXL = 42,
        Giant = 60,
    }

    export enum Weight {
        Normal = '400',
        SemiBold = '600',
        Bold = '700',
    }

    export function getResponsiveSize(size: Size): number {
        if(UIUtilsEjsVariables.isUserOnTabletApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) return size * uiGameManager.canvasController.appH / 600
        return size * uiGameManager.canvasController.appH / 700
    }
}
